"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6397],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 6397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Boxes_InfoBox2; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/uikit/Buttons/CarplannerButton.tsx


const _excluded = ["title", "width", "action", "disabled", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const CarplannerButton = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    title,
    width,
    action,
    disabled,
    onClick
  } = _ref,
      others = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  const buttonSize = (0,dist_index_esm/* useBreakpointValue */.Sx)(['md', 'lg']);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, _objectSpread(_objectSpread({
    variant: "outline",
    bg: "primaryGreen.600",
    color: "baseWhite",
    fontFamily: "Montserrat-SemiBold",
    borderRadius: 4,
    display: "block",
    overflow: "hidden",
    title: title,
    disabled: disabled,
    width: width || '100%',
    size: buttonSize,
    borderColor: "primaryGreen.300",
    px: {
      base: '0.75rem',
      md: '1rem'
    },
    _active: {
      bg: 'primaryGreen.800',
      borderColor: 'primaryGreen.800',
      color: 'baseWhite'
    },
    _hover: {
      bg: disabled ? '' : 'primaryGreen.300',
      borderColor: disabled ? '' : 'primaryGreen.900',
      color: disabled ? '' : 'baseWhite'
    },
    _disabled: {
      bg: 'baseNeutral.200',
      color: 'baseNeutral.400',
      cursor: 'default'
    },
    onClick: onClick
  }, others), {}, {
    children: action
  }));
});
/* harmony default export */ var Buttons_CarplannerButton = (CarplannerButton);
;// CONCATENATED MODULE: ./src/components/Boxes/InfoBox2.tsx






const Icon = /*#__PURE__*/styled_components_browser_esm["default"].span.withConfig({
  componentId: "sc-1ko8sjm-0"
})(["& svg{display:inline-block;margin:auto;}"]);

const InfoBox2 = _ref => {
  let {
    title,
    boldTitle,
    description,
    boldDescription,
    action,
    actionTitle,
    href,
    icon
  } = _ref;
  const startTitleIndex = title.indexOf(boldTitle);
  let beforeBoldTitle;
  let afterBoldTitle;

  if (startTitleIndex !== -1) {
    beforeBoldTitle = title.substring(0, startTitleIndex);
    afterBoldTitle = title.substring(startTitleIndex + boldTitle.length);
  }

  const startDescriptionIndex = description.indexOf(boldDescription);
  let beforeBoldDescription;
  let afterBoldDescription;

  if (startDescriptionIndex !== -1) {
    beforeBoldDescription = description.substring(0, startDescriptionIndex);
    afterBoldDescription = description.substring(startDescriptionIndex + boldDescription.length);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    bg: "primaryGreen.50",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
      as: index_esm/* Stack */.Kq,
      maxW: "100%",
      py: 10,
      textAlign: "center",
      p: "l",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
        templateColumns: {
          base: '1fr',
          sm: '1fr',
          md: '1fr 1.1fr 1.1fr'
        },
        marginY: "xxl",
        spacing: {
          base: 'l',
          sm: 'l',
          md: 'xl'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
          textAlign: {
            base: 'center',
            sm: 'center',
            md: 'right'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
            children: icon
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
            color: "baseDark",
            fontFamily: "Montserrat-Regular",
            fontSize: "1.375rem",
            letterSpacing: "0.6px",
            lineHeight: "28.6px",
            whiteSpace: "nowrap",
            marginBottom: "xs",
            textAlign: {
              base: 'center',
              sm: 'center',
              md: 'left'
            },
            children: [beforeBoldTitle, /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: boldTitle
            }), afterBoldTitle]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
            color: "baseDark",
            fontFamily: "Montserrat-Regular",
            fontSize: "1rem",
            letterSpacing: "0.2px",
            lineHeight: "20.8px",
            whiteSpace: "pre-wrap",
            textAlign: {
              base: 'center',
              sm: 'center',
              md: 'left'
            },
            children: [beforeBoldDescription, /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: boldDescription
            }), afterBoldDescription]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
          my: "auto",
          textAlign: {
            base: 'center',
            sm: 'center',
            md: 'left'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
            href: href,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_CarplannerButton, {
              title: actionTitle,
              action: action,
              width: "12.438rem",
              textTransform: "uppercase",
              display: "inline"
            })
          })
        })]
      })
    })
  });
};

/* harmony default export */ var Boxes_InfoBox2 = (InfoBox2);

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);